import React from 'react';
import { Card, Col, Container, Row } from 'reactstrap';

// Import Images
import dashboard from "../../assets/images/gallium/dashboard-v2.jpg";
import createVM from "../../assets/images/gallium/create-vm-v2.jpg";
import vmList from "../../assets/images/gallium/vm-list.jpg";

import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

const Console = () => {
    return (
        <React.Fragment>

            <section className="section pt-4 pb-4 mb-4" id="console">
                <Container>
                    <Row className="align-items-center gy-4 mb-5">
                        <Col lg={6} className="order-2 order-lg-2">
                            <div className="text-muted">
                                <h5 className="fs-12 text-uppercase text-primary">Cloud Console</h5>
                                <h4 className="mb-3">Managed like Public Cloud</h4>
                                <p className="mb-4 ff-secondary">The Console provides you with all of the tools necessary to manage your servers and workloads from a single pane of glass.</p>

                                <Row>
                                    <Col sm={12}>
                                        <div className="vstack gap-2">
                                            <div className="d-flex">
                                                <div className="flex-shrink-0 me-3">
                                                    <FeatherIcon icon="cloud-lightning" className="icon-dual-primary" />
                                                </div>
                                                <div className="flex-grow-1">
                                                    <h5 className="fs-14 mb-3 mt-2">Familiar Experience</h5>
                                                    <p className='text-muted'>The experience managing workloads in Gallium is built to behave like the Public Cloud, no tool assembly required.</p>
                                                </div>
                                            </div>
                                            <div className="d-flex">
                                                <div className="flex-shrink-0 me-3">
                                                    <FeatherIcon icon="activity" className="icon-dual-primary" />
                                                </div>
                                                <div className="flex-grow-1">
                                                    <h5 className="fs-14 mb-3 mt-1">Inbuilt Monitoring</h5>
                                                    <p className='text-muted'>Native monitoring capabilities check your servers are in good health. Problems are reported to your helpdesk via Webhook.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    
                                </Row>
                            </div>
                        </Col>

                        <Col lg={6} sm={7} className="col-10 ms-auto order-1 order-lg-1 d-none d-lg-block">
                            <div>
                                <img src={dashboard} alt="" className="img-fluid img-thumbnail mx-auto rounded" style={{maxWidth: "80%"}}/>
                            </div>
                            <Card className="card-bg-fill rounded shadow-lg d-none d-lg-block join-code-box">
                                <img className="card-img img-fluid" src={vmList} alt="Card cap">
                                </img>
                            </Card>
                        </Col>

                        <Col lg={6} sm={7} className="col-10 mx-auto order-1 order-lg-1 d-block d-lg-none">
                            <div>
                                <img src={createVM} alt="" className="img-fluid img-thumbnail mx-auto rounded "/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Console;